import * as React from 'react';

const RenderErrors = (props: { errors?: string[] }) => {
    if (props.errors) {
        return <div className="error__div">
                   <ul>
                       {props.errors.map((error, i) => <li key={i}>{error}</li>)}
                   </ul>
               </div>;
    }
    return <div></div>;;
}

function FlattenErrors(errorData: { [X: string]: string[] }) {
    var errors = Object.keys(errorData).map(field =>
        errorData[field]).reduce((acc, xs) => acc.concat(xs), []);
    // distinct
    return Object.keys(errors.reduce((acc, x) => ({ ...acc, [x]:0 }), {}))
}

export { RenderErrors };
export { FlattenErrors };
